import * as types from '../constantes/user';

export const SignReducer = (state = {}, action) => {
  switch (action.type) {
    case types.USER_SIGNIN_REQUEST:
      return {
        loading: true,
      };

    case types.USER_SIGNIN_SUCESS:
      return {
        loading: false,
        userInfo: action.payload,
      };

    case types.USER_SIGNIN_ERROR:
      return {
        loading: false,
        error: action.payload,
      };

    case types.USER_SIGNIN_RESET:
      return {};

    case types.USER_SIGNOUT:
      return {};

    default:
      return state;
  }
};

export const CreateUserReducer = (state = {}, action) => {
  switch (action.type) {
    case types.CREATE_USER_REQUEST:
      return {
        loading: true,
      };

    case types.CREATE_USER_SUCESS:
      return {
        loading: false,
        success: true,
      };

    case types.CREATE_USER_ERROR:
      return {
        loading: false,
        error: action.payload,
      };

    case types.CREATE_USER_RESET:
      return {};

    default:
      return state;
  }
};

export const GetUserProjectReducer = (state = { loading: true }, action) => {
  switch (action.type) {
    case types.GET_USER_PROJECT_REQUEST:
      return {
        loading: true,
      };
    case types.GET_USER_PROJECT_SUCESS:
      return {
        loading: false,
        listProjects: action.payload,
      };
    case types.GET_USER_PROJECT_ERROR:
      return {
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export const SearchUsersReducer = (state = { loading: true }, action) => {
  switch (action.type) {
    case types.SEARCH_USERS_REQUEST:
      return {
        loading: true,
      };
    case types.SEARCH_USERS_SUCESS:
      return {
        loading: false,
        listUsers: action.payload,
      };
    case types.SEARCH_USERS_ERROR:
      return {
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export const UpdateUserReducer = (state = {}, action) => {
  switch (action.type) {
    case types.UPDATE_USER_REQUEST:
      return {
        loading: true,
      };

    case types.UPDATE_USER_SUCESS:
      return {
        loading: false,
        success: true,
      };

    case types.UPDATE_USER_ERROR:
      return {
        loading: false,
        error: action.payload,
      };

    case types.UPDATE_USER_RESET:
      return {};

    default:
      return state;
  }
};

export const RecoverPasswordUserReducer = (state = {}, action) => {
  switch (action.type) {
    case types.RECOVER_PASSWORD_USER_REQUEST:
      return {
        loading: true,
      };

    case types.RECOVER_PASSWORD_USER_SUCESS:
      return {
        loading: false,
        success: true,
      };

    case types.RECOVER_PASSWORD_USER_ERROR:
      return {
        loading: false,
        error: action.payload,
      };

    case types.RECOVER_PASSWORD_USER_RESET:
      return {};

    default:
      return state;
  }
};

export const SearchSpecifyUserReducer = (state = { loading: true }, action) => {
  switch (action.type) {
    case types.SEARCH_SPECIFY_USER_REQUEST:
      return {
        loading: true,
      };
    case types.SEARCH_SPECIFY_USER_SUCESS:
      return {
        loading: false,
        searchSpecifyUser: action.payload,
      };
    case types.SEARCH_SPECIFY_USER_ERROR:
      return {
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export const UpdateAdminUserReducer = (state = {}, action) => {
  switch (action.type) {
    case types.UPDATE_ADMIN_USER_REQUEST:
      return {
        loading: true,
      };

    case types.UPDATE_ADMIN_USER_SUCESS:
      return {
        loading: false,
        success: true,
      };

    case types.UPDATE_ADMIN_USER_ERROR:
      return {
        loading: false,
        error: action.payload,
      };

    case types.UPDATE_ADMIN_USER_RESET:
      return {};

    default:
      return state;
  }
};

export const SearchCompanyUserReducer = (state = { loading: true }, action) => {
  switch (action.type) {
    case types.SEARCH_COMPANY_USERS_REQUEST:
      return {
        loading: true,
      };
    case types.SEARCH_COMPANY_USERS_SUCESS:
      return {
        loading: false,
        searchCompanyUser: action.payload,
      };
    case types.SEARCH_COMPANY_USERS_ERROR:
      return {
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export const ResendEmailUserReducer = (state = {}, action) => {
  switch (action.type) {
    case types.RESEND_EMAIL_USER_REQUEST:
      return {
        loading: true,
      };

    case types.RESEND_EMAIL_USER_SUCESS:
      return {
        loading: false,
        success: true,
      };

    case types.RESEND_EMAIL_USER_ERROR:
      return {
        loading: false,
        error: action.payload,
      };

    case types.RESEND_EMAIL_USER_RESET:
      return {};

    default:
      return state;
  }
};
